import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Container, Header, TopSaveWrapper } from "../formComponents.styles";
import {
  BlueButton,
  SaveButtonContainer,
  StyledForm,
} from "../../Admin.styles";
import { Question } from "./checkIn.types";
import {
  CheckInSection,
  extractQuestions,
  oneToThree,
} from "./checkInQuestions";
import {
  CheckinType,
  EmployeeTitle,
  MonthNames,
} from "../../../../services/api/types/Members";
import { Api } from "../../../../services/api";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "../../../../services/hooks/queryParams";
import { useMemberDetails } from "../../../../services/hooks/MemberDetails";
import { useAppSelector } from "../../../../store/hooks";
import { makeName } from "../../../../services/hooks/MembersList";

const questions: Array<Question> = [
  {
    type: "TextInput",
    label: "Team Member Name",
    name: "memberName",
    placeholder: "Name",
  },
  {
    type: "TextInput",
    label: "Team Leader Name",
    name: "leaderName",
    placeholder: "Name",
  },
  {
    type: "TextInput",
    label: "Reviewer Name",
    name: "reviewerName",
    placeholder: "Name",
  },
  {
    type: "TextInput",
    label: "Position",
    name: "position",
    placeholder: "Position",
  },
  { type: "DatePicker", name: "hireDate", label: "Hire Date" },
  { type: "DatePicker", name: "reviewDate", label: "Review Date" },
  {
    type: "RadioList",
    label:
      "On a sale from 1-3 (1 no, 3 yes), do you receive superstar training?",
    name: "trainingExperience",
    options: [...oneToThree],
    hasComments: true,
  },
  {
    type: "RadioList",
    label:
      "On a scale from 1-3, (1 no, 3 yes), do you feel like your team leader is passionate about your success?",
    name: "leaderSuccess",
    options: [...oneToThree],
    hasComments: true,
  },
  {
    type: "RadioList",
    label:
      "On a scale from 1-3, (1 no, 3 yes), does your team leader talk and communicate in a way you like?",
    name: "leaderCommunication",
    options: [...oneToThree],
    hasComments: true,
  },
  {
    type: "RadioList",
    label:
      "On a scale from 1-3, (1 no, 3 yes), do you see yourself working here in 12 months?",
    name: "workingHere",
    options: [...oneToThree],
    hasComments: true,
  },
  {
    type: "RadioList",
    label:
      "On a scale from 1-3, (1 no, 3 yes), how would you rate our benefits compared to your previous employer?",
    name: "benefits",
    options: [...oneToThree],
    hasComments: true,
  },
  {
    type: "TextArea",
    label: "What is most satisfying about your role/career?",
    name: "mostSatisfying",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "What is least satisfying about your role/career?",
    name: "leastSatisfying",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "Are the job duties as expected?",
    name: "duties",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "Do you receive sufficient feedback about your performance?",
    name: "feedback",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "Do you feel accepted by the team?  If not, why?",
    name: "acceptedByTeam",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "What would you improve to make our workplace better?",
    name: "makeWorkspaceBetter",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "What is our company mission statement? Please explain.",
    name: "companyMissionStatement",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "What are our core values? Please explain.",
    name: "coreValues",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "Do you know what a pickle is? Please explain.",
    name: "pickle",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label:
      "Was there anything that Culture Week did not prepare you for? Is there anything that you learned about in Culture Week, but have not actually seen put into practice?",
    name: "cultureWeek",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label:
      "Can you name the companies under Milestone's umbrella?  What are their specialties?",
    name: "milestoneCompanies",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label:
      "What did the last company offer that Milestone does not? What does Milestone offer that your last company did not?",
    name: "missingFromMilestone",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label:
      "If you were running the company, is there anything that you would change? If so, please explain.",
    name: "changeMilestone",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "Are you getting Gus' emails?",
    name: "gusEmails",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label:
      "Do you feel the company supplies you with the tools you need to be successful? Please explain.",
    name: "companyTools",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "What are your career goals here at Milestone?",
    name: "careerGoals",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label:
      "What policy/procedures make your job more difficult, if any? Please explain.",
    name: "jobDifficult",
    placeholder: "Comments",
  },
  {
    type: "TextArea",
    label: "What are your overall thoughts on Milestone?",
    name: "thoughts",
    placeholder: "Comments",
  },
];

export const NinetyDayCheckIn: React.FC<{}> = () => {
  const history = useHistory();
  const queryParams = useQuery();
  const month = queryParams.get("month");
  const monthIndex = MonthNames.findIndex(value => value === month);
  const year = queryParams.get("year");
  const { memberId, checkInId } =
    useParams<{ memberId: string; checkInId: string }>();
  const memberDetails = useMemberDetails(memberId);
  const user = useAppSelector(state => state.auth.user);
  const [titles, setTitles] = useState(new Map<string, EmployeeTitle>());

  const [formValues, setFormValues] = useState<Record<string, any>>({});

  const [loaded, setLoaded] = useState(false);

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type="submit">Submit</BlueButton>
    </SaveButtonContainer>
  );

  const { values, Schema, components } = extractQuestions(questions);

  const getCheckIn = async () => {
    //load checkIn
    const res = await Api.members.getCheckIn(memberId, checkInId);
    const checkIn = JSON.parse(res.data.review);
    setFormValues(checkIn);
    setLoaded(true);
  };

  const setValues = async () => {
    if (checkInId) {
      getCheckIn();
    } else {
      if (memberDetails) {
        if (!titles.size) {
          const res = await Api.members.getTitles();
          const titles = new Map<string, EmployeeTitle>();
          //build titles map and find the member's title
          for (const title of res.data) {
            titles.set(title.name, title);
            if (
              memberDetails.employmentInfo &&
              memberDetails.employmentInfo.employeeTitleId === title.id
            ) {
              values.position = title.name;
            }
          }
          setTitles(titles);
        }
        values.memberName = makeName(memberDetails.member);
        values.reviewerName = makeName(user);
        if (memberDetails.teamLead) {
          values.leaderName = memberDetails.teamLead.name;
        }
        values.hireDate = memberDetails.member.hireDate;
        values.reviewDate = new Date();
        setFormValues(values);
        setLoaded(true);
      }
    }
  };

  useEffect(() => {
    setValues();
  }, [checkInId, memberDetails]);

  const submitValues = async (values: any) => {
    try {
      if (checkInId) {
        await Api.members.updateCheckIn(
          memberId,
          checkInId,
          values,
          new Date(Number(year), monthIndex),
          CheckinType.NINETY_DAY_CHECKIN
        );
      } else {
        await Api.members.createCheckIn(
          memberId,
          values,
          new Date(Number(year), monthIndex),
          CheckinType.NINETY_DAY_CHECKIN
        );
      }
      history.push(`/admin/members/${memberId}/checkIns`);
    } catch (error) {
      console.error("Update CheckIn", error);
    }
  };

  return (
    <Container>
      {loaded && (
        <Formik
          initialValues={formValues}
          validationSchema={Schema}
          onSubmit={submitValues}
        >
          {() => (
            <StyledForm>
              <TopSaveWrapper>{SaveButtons}</TopSaveWrapper>

              <CheckInSection>
                <Header>90 Day Review</Header>
                {components}
              </CheckInSection>
              {SaveButtons}
            </StyledForm>
          )}
        </Formik>
      )}
    </Container>
  );
};
